import React from "react";

export default function StrictTimed() {
  return <div>strict</div>;
}
